import * as React from 'react';
import { SVGProps } from 'react';

const IconShareSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m16.055 16.716-7.113-4.124A2.994 2.994 0 0 0 9 12.04V12c0-.188-.017-.372-.05-.55l7.13-4.133c.523.44 1.187.707 1.92.707 1.66 0 3-1.345 3-3.012V5a3 3 0 1 0-6 0v.012l.001.069c.005.174.024.344.057.509L7.943 9.714A3 3 0 0 0 3 12v.04c0 .206.02.39.06.556a3.001 3.001 0 0 0 4.685 1.845.575.575 0 0 0 .193-.112l7.112 4.123a3 3 0 1 0 1.005-1.736Z" />
  </svg>
);
export default IconShareSizeM;
